import { Link } from "react-router-dom";
import { Nav } from "@/components/Nav";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#101010] text-[#F5F5F0]" data-testid="not-found-page">
      <Nav />
      <div className="flex flex-col items-center justify-center gap-4 py-32">
        <h1 className="font-display font-black uppercase text-3xl tracking-tighter">Page not found</h1>
        <Link to="/" className="font-mono text-xs uppercase tracking-widest text-[#CCFF00] hover:underline">
          Back home
        </Link>
      </div>
    </div>
  );
}
